import { FC, ReactElement, useRef, useState } from 'react'
import styled from 'styled-components'
// import of some global styles can be deleted if you don't use them
import colorVariables from '../../Globals/colors.module.css'
import fontVariables from '../../Globals/fonts.module.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'

import ContentGrid from 'components/ContentGrid'
import Column from 'components/Column'
import { useEffectOnce } from 'usehooks-ts'
import { Scroller } from 'components/Scroller'
import ChartComponent from '../ChartComponent'
import { TextWidth } from '@ta-interaktiv/react-disco-grid'
import { Link } from '@ta-interaktiv/contentbricks'
import TextExpander from '../ToggleText'
import data from '../../assets/data'
import dataFootnotes from '../ToggleText/data-FootnotesBox.js'
// import {
//   FrontElement,
//   FrontElementText,
//   FrontElementTitle,
// } from 'components/FrontElement'



const MainComponent: FC<MicroFrontendProps> = ({
  tenant,
  colorMode,
  properties,
}): ReactElement => {
  const [height, setHeight] = useState(0)
  const [initialHeight, setInitialHeight] = useState(0)
  const [headerHeight, setHeaderHeight] = useState(0)
  const dataLanguage = (tenant?.lang === "fr") ? (data.fr) : (data.de)
  useEffectOnce(() => {
    const headerElement = document.querySelector('[class*=FullHeader_root]')

    let headerHeight = 0
    if (headerElement) {
      // check if header is sticky
      const headerStyle = window.getComputedStyle(headerElement)
      const isSticky =
        headerStyle.position === 'sticky' && headerStyle.top === '0px'

      if (isSticky) {
        headerHeight = headerElement.clientHeight
        setHeaderHeight(headerHeight)
      }
    }
    setInitialHeight(window.innerHeight - headerHeight)
    // setup resize listener
    const handleResize = () => {
      setHeight(window.innerHeight - headerHeight)
    }
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  })

  const globalClasses = [
    colorVariables.globalColors,
    fontVariables.globalFonts,
    colorMode === 'dark' ? colorVariables.globalColorsDark : '',
  ]
  return (
    <AppContainer className={globalClasses.join(' ')}>
      {properties?.component === 'BeeswarmChart' && (
        <div style={{ backgroundColor: '#D3343F' }}>
          {/* <h1>Wenn die Schweiz 100 Personen wären</h1> */}
          <ContentGrid>
            <>
              {height > 0 && (
                <Column wide>
                  <Scroller
                    headerHeight={headerHeight}
                    defaultDistance={initialHeight}
                    front={dataLanguage.map((item) => {
                      return (
                        <></>
                        // <FrontElement key={item.title}>
                        //   {/* <FrontElementTitle>{item.title}</FrontElementTitle> */}
                        //   <FrontElementText>{item.text}</FrontElementText>
                        // </FrontElement>
                      )
                    })}
                    back={(index, id) => {
                      const currentScene =
                      
                      dataLanguage[
                          Math.min(Math.max(index, 0), dataLanguage.length - 1)
                        ]
                      const numberOfAllPersons = currentScene.categories
                        .map((cat) => cat.value)
                        .reduce((a, b) => a + b, 0)
                      // console.log(
                      //   currentScene.title,
                      //   'has',
                      //   numberOfAllPersons,
                      //   'persons'
                      // )

                      return (
                        <>
                          <div
                            style={{
                              height: height + 'px',
                              overflow: 'visible',
                            }}
                          >
                            {currentScene && (
                              <ChartComponent
                                colorMode={colorMode}
                                sceneIndex={index}
                                currentScene={currentScene}
                                headerHeight={headerHeight}
                              />
                            )}
                          </div>
                        </>
                      )
                    }}
                  />
                </Column>
              )}
            </>
          </ContentGrid>
        </div>
      )}

    {properties?.component === 'FootnotesBox' && (
      <TextWidth>
        <TextExpanderWrapper>
          <TextExpander
            // title=""
            trackingID='Mehr Lesen'
            colorMode={colorMode}
            tenant={tenant}
            language={(tenant?.lang === "fr") ? (dataFootnotes.fr) : (dataFootnotes.de)}
          />
        </TextExpanderWrapper>
      </TextWidth>
    )}
    </AppContainer>
  )
}
const TextExpanderWrapper = styled.div`
  color: var(--text-color) !important;
`
const AppContainer = styled.div`
  font-family: var(--font-noto);
  font-size: 1.8rem;
  line-height: 3rem;
  @media (min-width: 1920px) {
    margin: 0 -2000px;
  }

  /* background-color: var(--red-main); */
`

export default MainComponent
